import {useTranslation} from 'react-i18next';
import {useStylesEscalationLevel} from '../escalationLevel';
import {useSelector} from 'react-redux';
import {onlyActiveSingleWards} from '../../../../store/reducers/ward';
import {FormLabel, Grid} from '@mui/material';
import {AgyleTable, createAgyleTableColumn} from '../../../../components/table/AgyleTable';
import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import IconButton from '@mui/material/IconButton';
import HistoryIcon from '@mui/icons-material/History';
import EscalationHistory from '../../../../components/map/escalationHistory';
import useOpenState from '../../../../hooks/useOpenState';

const COLUMNS = [
    createAgyleTableColumn('no', 'No.', 1, null, 'count', 'notSort', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('name', 'Ward Name', 2, 'name', 'string', 'notSort', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('wardsId', 'Ward id', 3, 'wardsId', 'string', 'notSort', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('hospitalId', 'Hospital id', 4, 'hospitalId', 'string', 'notSort', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('status', 'Escalation Level', 5, 'status', 'escalationLevel', 'notSort', 'medium', 'center', true, false, null, null, null),
    createAgyleTableColumn('action', 'History', 6, null, 'action', 'notSort', 'medium', 'right', true, false, null, null, null),
];

const DEFAULT_WARD = {
    wardId: null,
    hospitalId: null,
}

const CurrentLevels = ({levels}) => {
    const {t} = useTranslation();
    const classes = useStylesEscalationLevel();

    // Selectors
    const wards = useSelector(onlyActiveSingleWards);

    const [data, setData] = useState([]);
    const [stats, setStats] = useState({
        all: 0,
        planned: 0,
        unplanned: 0,
    });

    // History
    const [selectedWard, setSelectedWard] = useState(DEFAULT_WARD);
    const [isHistoryOpen, openHistory, closeHistory] = useOpenState(false, true);

    useEffect(() => {
        const dataTable = [];

        _.forEach(wards, w => {
            const find = _.find(levels, {wardId: w?.wardsId[0], hospitalId: w.hospitalId});
            dataTable.push({
                name: w?.name || '-',
                wardsId: w?.wardsId?.[0] || '-',
                hospitalId: w?.hospitalId || '-',
                __id: find?.__id || null,
                status: find?.level || 'core',
            });
        });
        const sortOrder = ['unplanned', 'planned', 'core'];
        setStats({
            all: dataTable?.length || 0,
            planned: _.filter(dataTable, w => w.status === 'planned')?.length || 0,
            unplanned: _.filter(dataTable, w => w.status === 'unplanned')?.length || 0,
        });
        setData(_.orderBy(dataTable, [item => sortOrder.indexOf(item.status)]));
    }, [wards, levels]);

    const renderCustomButtons = (obj) => {
        return (
            <IconButton
                size="small"
                onClick={() => {
                    setSelectedWard({
                        wardId: obj?.wardsId,
                        hospitalId: obj?.hospitalId,
                    });
                    openHistory();
                }}
            >
                <HistoryIcon/>
            </IconButton>
        );
    };

    const handleCloseHistory = () => {
        closeHistory();
        setSelectedWard(DEFAULT_WARD);
    };

    const renderStats = (field, title) => {
        return (
            <Grid item xs={4} className={classes.statsChip}>
                <FormLabel className={classes.bold}>
                    {title}
                </FormLabel>

                <div className={classes.statsCount}>
                    {stats[field] || 0}
                </div>
            </Grid>
        );
    };

    return (
        <>
            <div className={classes.container}>
                <div className={classes.divRow} style={{gap: 10, marginBottom: 10}}>
                    {renderStats('all', t('All Wards'))}
                    {renderStats('planned', t('Planned'))}
                    {renderStats('unplanned', t('Unplanned'))}
                </div>

                <FormLabel className={classes.bold}>
                    {t('Current Wards Escalation Level')}
                </FormLabel>

                <div>
                    <AgyleTable
                        disableFilter
                        columns={COLUMNS}
                        data={data}
                        tableContainerClass={classes.table}
                        edRefresh
                        customActionItem={renderCustomButtons}
                    />
                </div>
            </div>

            {isHistoryOpen &&
                <EscalationHistory
                    wardId={selectedWard.wardId}
                    hospitalId={selectedWard.hospitalId}
                    open={isHistoryOpen}
                    onClose={handleCloseHistory}
                />
            }
        </>

    );
};

export default CurrentLevels;